import { AvailableLanguages, CountryCode, ShopConfig } from './types/types'
import { PRODUCTION_ENVIRONMENT } from './utils/enums'

export const DEFAULT_SHOP_ID = 'notino.cz'
export const DEFAULT_LANG_TAG = 'cs-CZ'
export const DEFAULT_LOCALE = 'cs'
export const DEFAULT_COUNTRY_CODE = 'CZ'

// NOTE: when adding new language, add it to AVAILABLE_LANGUAGES and shopsConfig
export const AVAILABLE_LANGUAGES: AvailableLanguages[] = ['cs', 'sk', 'bg', 'hu', 'ro', 'de-AT', 'hr']

export const COUNTRY_CODES: CountryCode[] = ['CZ', 'SK', 'BG', 'HU', 'RO', 'AT', 'HR']

export const shopsConfig: ShopConfig[] = [
	{ shopId: 'notino.cz', url: `https://www.notino.cz`, locale: DEFAULT_LOCALE, lang: DEFAULT_LANG_TAG, countryCode: DEFAULT_COUNTRY_CODE },
	{ shopId: 'notino.sk', url: `https://www.notino.sk`, locale: 'sk', lang: 'sk-SK', countryCode: 'SK' },
	{ shopId: 'notino.bg', url: `https://www.notino.bg`, locale: 'bg', lang: 'bg-BG', countryCode: 'BG' },
	{ shopId: 'notino.hu', url: `https://www.notino.hu`, locale: 'hu', lang: 'hu-HU', countryCode: 'HU' },
	{ shopId: 'notino.ro', url: `https://www.notino.ro`, locale: 'ro', lang: 'ro-RO', countryCode: 'RO' },
	{ shopId: 'notino.at', url: `https://www.notino.at`, locale: 'de-AT', lang: 'de-AT', countryCode: 'AT' },
	{ shopId: 'notino.hr', url: `https://www.notino.hr`, locale: 'hr', lang: 'hr-HR', countryCode: 'HR' }
]

const mapArrayByKey = <T extends Record<string, any>, K extends keyof T>(array: T[], key: K): Record<T[K], Omit<T, K>> => {
	return array.reduce(
		(acc, item) => {
			const { [key]: keyValue, ...rest } = item
			acc[keyValue] = rest
			return acc
		},
		{} as Record<T[K], Omit<T, K>>
	)
}

export const shopsConfigById = mapArrayByKey(shopsConfig, 'shopId')

export const getEnvironmentSpecificShopsConfig = (productionEnvironment: PRODUCTION_ENVIRONMENT): ShopConfig[] => {
	let config = [...shopsConfig]

	switch (productionEnvironment) {
		case PRODUCTION_ENVIRONMENT.TEST: {
			config = shopsConfig.map((shop) => {
				switch (shop.shopId) {
					case 'notino.cz':
						return { ...shop, url: 'https://cz.dev.notino.app' }
					case 'notino.sk':
						return { ...shop, url: 'https://sk.dev.notino.app' }
					case 'notino.bg':
						return { ...shop, url: 'https://bg.dev.notino.app' }
					case 'notino.hu':
						return { ...shop, url: 'https://hu.dev.notino.app' }
					case 'notino.ro':
						return { ...shop, url: 'https://ro.dev.notino.app' }
					case 'notino.at':
						return { ...shop, url: 'https://at.dev.notino.app' }
					case 'notino.hr':
						return { ...shop, url: 'https://hr.dev.notino.app' }
					default:
						return { ...shop }
				}
			})
			break
		}
		case PRODUCTION_ENVIRONMENT.UAT:
			config = shopsConfig.map((shop) => {
				switch (shop.shopId) {
					case 'notino.cz':
						return { ...shop, url: 'https://cz.stg.notino.app' }
					case 'notino.sk':
						return { ...shop, url: 'https://sk.stg.notino.app' }
					case 'notino.bg':
						return { ...shop, url: 'https://bg.stg.notino.app' }
					case 'notino.hu':
						return { ...shop, url: 'https://hu.stg.notino.app' }
					case 'notino.ro':
						return { ...shop, url: 'https://ro.stg.notino.app' }
					case 'notino.at':
						return { ...shop, url: 'https://at.stg.notino.app' }
					case 'notino.hr':
						return { ...shop, url: 'https://hr.stg.notino.app' }
					default:
						return { ...shop }
				}
			})
			break
		default:
			break
	}
	return config
}

export const getEnvironmentAndLocaleSpecificShopsConfig = (productionEnvironment: PRODUCTION_ENVIRONMENT, locale: string): ShopConfig => {
	const config = getEnvironmentSpecificShopsConfig(productionEnvironment)

	return config.find((shop) => shop.locale === locale || shop.lang === locale) || config[0]
}

/**
 * Enable advanced markers. You don't need to create a map ID, and can instead use the demo map ID DEMO_MAP_ID.
 * https://developers.google.com/maps/documentation/javascript/map-ids/mapid-over
 */
export const DEFAULT_MAP_ID = 'DEMO_MAP_ID'
